(function ($) {

	function add_cart_item(variant_id, quantity, location){

		let url = ghostpress_params.ajax_url + "&action=add_variant_to_cart",
			data = {
				"variant_id": variant_id,
				"quantity": quantity,
				"location": location,
			}

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				jQuery(document).trigger('cart_updated')
				jQuery(document).trigger('open_modal', ['cart'])
				jQuery(document).trigger('gp_update_checkout')
			})
	}

	function update_cart_item() {

		let data = JSON.parse($(this).attr('data-cart-update-item'))

		gp_ajax({
			url: ghostpress_params.ajax_url + "&action=update_variant_in_cart",
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				jQuery(document).trigger('cart_updated')
				jQuery(document).trigger('gp_update_checkout')
			})
	}

	function init_cart() {

		// Add item to cart
		$('#form-add-to-cart').off('submit').submit(function(e){
			e.preventDefault()
			add_cart_item($(this).find('[name="variant_id"]').val(), $(this).find('[name="quantity"]').val(), "product_page")
		})

		// Update cart item
		$('[data-cart-update-item]').off('click').click(update_cart_item)
	}

	// Init cart functions
	$(document).gp_ready(init_cart)

})(jQuery);
